// extracted by mini-css-extract-plugin
module.exports = {"container":"Icon_container__wZSDZ","svg":"Icon_svg__NQKae","iconWithLabel":"Icon_iconWithLabel__bk4yN","label":"Icon_label__2dZsH"};